var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"acountStatus"},[_c('div',{staticClass:"mainTitle text-center my-3"},[_c('h3',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t('openTrades')))])]),_vm._v(" "),_c('div',{staticClass:"mapIco-list-table mt-4"},[_c('app-open-trades',{attrs:{"pageName":'open-trade'}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3da96ac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fxView/tradingAccounts/open_trades_listing.vue
// module id = null
// module chunks = 